import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const ArrowDown_sm = (props) => {
    const width = props.width ? props.width + 'px' : '20px';
    const height = props.height ? props.height + 'px' : '20px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 20 20"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15.5303 11.4697C15.8232 11.7626 15.8232 12.2374 15.5303 12.5303L10.5303 17.5303C10.3897 17.671 10.1989 17.75 10 17.75C9.80109 17.75 9.61032 17.671 9.46967 17.5303L4.46967 12.5303C4.17678 12.2374 4.17678 11.7626 4.46967 11.4697C4.76256 11.1768 5.23744 11.1768 5.53033 11.4697L9.25 15.1893L9.25 3C9.25 2.58579 9.58579 2.25 10 2.25C10.4142 2.25 10.75 2.58579 10.75 3L10.75 15.1893L14.4697 11.4697C14.7626 11.1768 15.2374 11.1768 15.5303 11.4697Z"
            />
        </SvgStyled>
    );
};

export default ArrowDown_sm;
